/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import AsyncTypeahead from 'react-bootstrap-typeahead/lib/AsyncTypeahead.react'; 
import Menu from 'react-bootstrap-typeahead/lib/Menu.react';
import MenuItem from 'react-bootstrap-typeahead/lib/MenuItem.react';
import Highlighter from 'react-bootstrap-typeahead/lib/Highlighter.react';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import SearchService from '../../services/searchService';
import groupBy from 'lodash/groupBy';
import startsWith from 'lodash/startsWith';
import roleTypes from '../../constants/roleTypes';

class Search extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.search = this.search.bind(this);
        this.selected = this.selected.bind(this);  
        this.renderMenu = this.renderMenu.bind(this);
        this.state = {
            typeaheadLoading: false,
            typeaheadOptions: [],
            selected: null
        };
    }

    componentWillMount() {  

    }   

    componentDidMount() {

    }    

    search(query) {
        this.setState({typeaheadLoading: true});
        SearchService.search(query)
            .then(results => {
                const items = [];
                const keys = Object.keys(results);
                keys.forEach(key => {
                    const resultItems = results[key];
                    resultItems.forEach(item => {
                        items.push({ ...item, section: key, sortIndex: this.getSortIndex(key) });
                    });
                });   
                items.sort((a, b) => a.sortIndex - b.sortIndex);             
                this.setState({
                    typeaheadLoading: false,
                    typeaheadOptions: items
                });
            } );
    }

    getSortIndex(resultType) {
        if(resultType === 'Influences') {
            return 1;
        }
        else if(resultType === 'Genre') {
            return 2;
        }
        else if(resultType === 'Artists') {
            return 3;
        }
        else if(resultType === 'Producers') {
            return 4;
        }
        else if(resultType === 'Fans' || resultType === 'Musicians' || resultType === 'Managers' || resultType === 'Promoters' || resultType === 'RecordingStudios' || resultType === 'RecordLabels' || resultType === 'Songwriters' || resultType === 'Venues') {
            return 5;
        }
        else if(resultType === 'Music' || resultType === 'Video') {
            return 6;
        }
        else {
            return 7;
        }
    }

    selected(items) {
        if(items.length === 1) {
            const item = items[0];
            if(item.type === 'Influence') {
                const roleType = roleTypes.find(r => r.public && r.type === item.referenceData);
                this.props.history.push(`/${roleType.route}/like/${item.label}`);
            }
            else if(item.type === 'Profile') {
                this.props.history.push(`/${item.referenceData}`);
            }
            else if(item.type === 'Video') {
                this.props.history.push(`/Video/${item.referenceData}`);
            }
            else if(item.type === 'Track') {
                this.props.history.push(`/Track/${item.referenceData}`);
            }
            else if(item.type === 'Gig') {
                this.props.history.push(`/Gigs/${item.referenceData}`);
            }
            else if(item.type === 'Genre') {
                this.props.history.push(`/Artists/${item.referenceData}`);
            }
            else if(item.type === 'ProfileType') {
                const roleType = roleTypes.find(r => r.public && r.type === item.referenceData);
                this.props.history.push(`/${roleType.route}`);
            }
        }
    }

    renderMenu(results, menuProps) {
        const grouped = groupBy(results, (r) => r.section === 'Influences' ? `Influences-${r.referenceData}` : r.section);
        let position = 0;
        const items = Object.keys(grouped).map((section) => {
            const {menuItems, currentPosition} = this.getMenuItems(grouped, section, position, menuProps);
            position = currentPosition;              
            return menuItems;
        });
        return <Menu {...menuProps}>{items}</Menu>;
    }

    getMenuItems(grouped, section, position, menuProps) {
        const menuItems = [];
        if(position !== 0) {
            menuItems.push(<Menu.Divider key={`${section}-divider`} />);
        }
        menuItems.push(
            <Menu.Header key={`${section}-header`}>
              {this.getSectionName(section)}
            </Menu.Header>
        );
        grouped[section].map((item, index) => {
            position++;
            menuItems.push(
                <MenuItem key={`${section}-${index}`} option={item} position={position}>
                    <Highlighter search={menuProps.text}>
                        {item.label}
                    </Highlighter>
                </MenuItem>
            );
        });
        return { menuItems, currentPosition: position };
    }

    getSectionName(section) {
        const roleType = roleTypes.filter(r => r.public).find(r => r.type + 's' === section);
        if(roleType) {
            return roleType.friendlyName + 's:';
        }
        else if(section === 'RoleTypes') {
            return 'Profile Types:';
        }
        else if(startsWith(section, 'Influences')) {
            const sectionArr = section.split('-');
            return sectionArr[1] == 'Fan' ? 'Fans of:' : `${sectionArr[1]}s influenced by:`;
        }
        return section + ':';
    }

    render() {
        return (
            <AsyncTypeahead id="mainSearch" minLength={3} isLoading={this.state.typeaheadLoading} onSearch={this.search} onChange={this.selected} options={this.state.typeaheadOptions} selected={this.state.selected} placeholder="Search by artist name, genre, track name..." autoComplete="off" renderMenu={this.renderMenu} />
        );
    }
}

Search.propTypes = {
    history: PropTypes.object.isRequired
};

export default withRouter(Search);